import { render, staticRenderFns } from "./choose-menu.vue?vue&type=template&id=8032adb2&scoped=true&"
import script from "./choose-menu.vue?vue&type=script&lang=js&"
export * from "./choose-menu.vue?vue&type=script&lang=js&"
import style0 from "./choose-menu.vue?vue&type=style&index=0&id=8032adb2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8032adb2",
  null
  
)

export default component.exports